<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col class="text-right" >
          <v-btn @click="refresh" :loading="loading">Обновить</v-btn>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет типов заказа"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="orderTypes"
              :search="search"
              :fixed-header="true"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              height="60vh"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка типов заказа... Подождите пожалуйста"
      >

      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import OrderTypeService from '../../../api/OrderTypeService'

    export default {
        name: 'OrderTypeIndex',
        components: {},
        data: () => ({
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            submitDialog: false,
            submitItem: null,
            orderTypes: [],
            options: {},
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            headers: [
                {
                    text: 'Название',
                    value: 'name',
                    sortable: false
                },
            ],
        }),
        mounted() {
          this.loading = true
          OrderTypeService.list().then(response => {
            this.orderTypes = response.data;
            this.loading = false
          })
        },

        methods: {
            refresh() {
                this.loading = true

                OrderTypeService.refresh()
                    .then(response => {
                        this.orderTypes = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
